const getters = {
   device: (state) => state.app.device,
   isLogged: (state) => state.auth.isLogged,
   token: (state) => state.auth.token,
   user: (state) => state.auth.user,
   visitedViews: (state) => state.tagsView.visitedViews,
   cachedViews: (state) => state.tagsView.cachedViews,
};
export default getters;
